'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _actions = require('./actions');

var actions = _interopRequireWildcard(_actions);

var _types = require('./types');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

exports.default = function (_ref) {
    var dispatch = _ref.dispatch;
    return function (next) {
        return function (action) {
            var nextAction = next(action);

            if (action.type === _types.UI_INIT) {
                return dispatch(actions.generateSubsectionState(action.payload.sectionsMenu));
            }

            return nextAction;
        };
    };
};
//# sourceMappingURL=middleware.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/ui-core-navigation/lib/cjs/redux/core-navigation-ui/middleware.js
 ** module id = 624
 ** module chunks = 1
 **/